export default "__VITE_ASSET__CZQ5YMQD__"